// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-button {
  background-color: #96f5d0;
  color: #343a40;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  border-color: #96f5d0;
  min-width: 150px;
  box-sizing: border-box;
  white-space: nowrap;
  letter-spacing: 0.01em;
  position: relative;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.custom-button:not(:disabled):hover {
  background-color: #76e6b8 !important;
  color: #343a40 !important;
  text-shadow: 0 0 0.01px #343a40;
}

.custom-button:disabled {
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  border-color: #d9d9d9 !important;
  cursor: not-allowed;
}

.custom-button:disabled:hover {
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  border-color: #d9d9d9 !important;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/button/customButton.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,gCAAgC;AAClC","sourcesContent":[".custom-button {\r\n  background-color: #96f5d0;\r\n  color: #343a40;\r\n  border-radius: 6px;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  border-color: #96f5d0;\r\n  min-width: 150px;\r\n  box-sizing: border-box;\r\n  white-space: nowrap;\r\n  letter-spacing: 0.01em;\r\n  position: relative;\r\n  transition: background-color 0.2s ease, color 0.2s ease;\r\n}\r\n\r\n.custom-button:not(:disabled):hover {\r\n  background-color: #76e6b8 !important;\r\n  color: #343a40 !important;\r\n  text-shadow: 0 0 0.01px #343a40;\r\n}\r\n\r\n.custom-button:disabled {\r\n  background-color: #f5f5f5 !important;\r\n  color: rgba(0, 0, 0, 0.25) !important;\r\n  border-color: #d9d9d9 !important;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.custom-button:disabled:hover {\r\n  background-color: #f5f5f5 !important;\r\n  color: rgba(0, 0, 0, 0.25) !important;\r\n  border-color: #d9d9d9 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
